var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconstelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64987 8.60995C8.09231 5.78751 12.3883 3.92678 14.5378 3.02777C20.675 0.460914 21.9503 0.0150233 22.7815 0.000142741C22.9643 -0.00293856 23.3731 0.0426195 23.6379 0.258661C23.8614 0.441082 23.9229 0.687507 23.9524 0.860462C23.9818 1.03342 24.0185 1.42741 23.9893 1.73527C23.6567 5.2491 22.2177 13.7763 21.4856 17.7118C21.1758 19.3771 20.5658 19.9354 19.9753 19.9901C18.6919 20.1088 17.7174 19.1373 16.4744 18.3179C14.5294 17.0359 13.4305 16.2378 11.5425 14.9867C9.36064 13.5409 10.7751 12.7462 12.0185 11.4476C12.344 11.1077 17.9985 5.93594 18.1079 5.46679C18.1216 5.40811 18.1343 5.18939 18.0051 5.0739C17.8759 4.95841 17.6851 4.99791 17.5475 5.02932C17.3524 5.07384 14.2452 7.13899 8.22584 11.2248C7.34386 11.8338 6.54499 12.1305 5.82924 12.1149C5.04017 12.0978 3.52233 11.6663 2.39397 11.2975C1.00999 10.8451 -0.0899675 10.606 0.00581422 9.83769C0.0557033 9.43752 0.603724 9.02828 1.64987 8.60995Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstelegram);
export default __webpack_public_path__ + "static/media/Iconstelegram.9e692a9dba8f2196c15cafe41d792766.svg";
export { ForwardRef as ReactComponent };